// extracted by mini-css-extract-plugin
module.exports = {"modalSpinner":"az_Lu","dialog":"az_Mu"};